<template>
  <section id="testimonial" class="n2-seccion n3-testimonios" v-if="NOTARIA?.Theme?.Home?.Testimonios?.Mostrar && lista.length"
    @mouseenter="pausado = true" @mouseleave="pausado = false">
    <div class="n2-contenedor n3-testimonios__caja n2-aparece">
      <div class="n2-estrellas" :aria-label="(actual.Estrellas || 5) + ' / 5'">
        <v-icon v-for="n in (Number(actual.Estrellas) || 5)" :key="n" size="22">{{ NOTARIA.Theme.Home.Testimonios.Icon || 'mdi-star' }}</v-icon>
      </div>
      <Transition name="n3-fundido" mode="out-in">
        <figure :key="indice" class="n3-testimonio">
          <blockquote>“{{ textoPlano(actual.Descripcion) }}”</blockquote>
          <figcaption>
            <img v-if="actual.Imagen" :src="imagenIDtoSRC(actual.Imagen)" :alt="actual.Nombre" loading="lazy" />
            <span>{{ actual.Nombre }}</span>
          </figcaption>
        </figure>
      </Transition>
      <div v-if="lista.length > 1" class="n3-puntos" role="tablist">
        <button v-for="(t, i) in lista" :key="i" type="button" role="tab" :aria-selected="i === indice"
          :aria-label="t.Nombre" :class="{ activo: i === indice }" @click="indice = i"></button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { textoPlano } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC } = useUtils()
// Panel: Testimonios (y su interruptor en Inicio)
const lista = computed(() => NOTARIA.value?.Testimonios ?? [])
const indice = ref(0)
const actual = computed(() => lista.value[indice.value] ?? lista.value[0] ?? {})
const pausado = ref(false)

// Pasa solo cada 7 s (salvo con el ratón encima o con "reducir movimiento")
let reloj = null
onMounted(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  reloj = setInterval(() => {
    if (!pausado.value && lista.value.length > 1) indice.value = (indice.value + 1) % lista.value.length
  }, 7000)
})
onBeforeUnmount(() => clearInterval(reloj))
</script>
